"use client";

import { api } from "@v1/backend/convex/_generated/api";
import type { Id } from "@v1/backend/convex/_generated/dataModel";
import { useQuery } from "convex/react";
import type { ReactElement } from "react";
import { MessengerTeamAvatar } from "./messenger-avatars";
import { useMessengerSurface } from "./messenger-context";
import { MessengerDetailHeader } from "./messenger-header";
import { MessengerTicketThread } from "./messenger-ticket-thread";
import { MessengerTicketSubtitle } from "./messenger-thread-parts";
import { useMessengerMarkRead } from "./use-messenger-mark-read";

/** A ticket opened from the Tickets list (also mail and WhatsApp tickets). */
export function MessengerTicketView({ taskId }: { readonly taskId: Id<"tasks"> }): ReactElement {
  const surface = useMessengerSurface();
  const ticket = useQuery(api.customerChat.messenger_thread.getTicket, { surface, task_id: taskId });
  useMessengerMarkRead({ kind: "ticket", taskId });
  if (ticket === undefined || ticket === null) return <MessengerDetailHeader title="" />;
  return (
    <>
      <MessengerDetailHeader
        title={ticket.summary.title || ticket.summary.number}
        leading={<MessengerTeamAvatar />}
        subtitle={<MessengerTicketSubtitle number={ticket.summary.number} status={ticket.summary.status} />}
      />
      <MessengerTicketThread key={taskId} taskId={taskId} done={ticket.summary.status === "done"} />
    </>
  );
}
